import { render, staticRenderFns } from "./customer-type.vue?vue&type=template&id=ed75650a&"
import script from "./customer-type.vue?vue&type=script&lang=ts&"
export * from "./customer-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports